import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const LegendLabelContainer = styled.div<{ theme: { token: GlobalToken } }>`
  margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
  color: ${({ theme: { token } }) => token.colorText};

  .name {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
  }

  .dates {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    margin-top: ${({ theme: { token } }) => token.marginXXS}px;
  }
`;
